/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KpfInputs */

const de__field_kpf = /** @type {(inputs: _Field_KpfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KPF`)
};

/**

* @param {_Field_KpfInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kpf = /** @type {((inputs?: _Field_KpfInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KpfInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kpf(inputs)
});